import { useState, useEffect, useContext, useRef } from "react";
import { addDays } from "date-fns/esm";
import { DatePicker, ModalComponent, Tabs } from "../../../../components";
import Table from "../tableComponent";
import restService from "../../../../../restService";
import UserContext from "../../../../../contexts/UserContext";
import CampaignContext from "../../../../../contexts/CampaignContext";
import DrawWinners from "./DrawWinners";
import { Modal } from "flowbite-react";
import Confetti from "react-confetti";
import { PulseLoader } from "react-spinners";

const TwitterCampaigns = () => {
  const [user] = useContext(UserContext);
  const [campaign] = useContext(CampaignContext);
  const Ref = useRef();

  const [width, setWidth] = useState();
  const [height, setHeight] = useState();
  const openRunADraw = (id) => {
    document.getElementById(id).classList.toggle("hidden");
  };
  const [isRewarding, setIsRewarding] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [drawWinners, setDrawWinners] = useState([]);

  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Entries");
  const [entries, setEntries] = useState([]);
  const [campaignUrl, setCampaignUrl] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [tweetOptions, setTweetOptions] = useState({
    retweeted: true,
    liked: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [showSendMessageModal, setShowSendMessageModal] = useState(false);
  const [selectedUserObject, setSelectedUserObject] = useState({
    content: "",
  });
  const handleClose = () => {
    setShowSendMessageModal(false);
  };
  const [includeComment, setIncludeComment] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [drawData, setDrawData] = useState({
    drawType: "CONSUMERS",
    // startDate: new Date(dateRange[0].startDate).toISOString(),
    // endDate: new Date(dateRange[0].endDate).toISOString(),
  });

  const handleIncludeComment = (e) => {
    setIncludeComment(e.target.checked);
  };
  const hadleTweetOptionChange = (e) => {
    // if (e.target.checked) {
    let name = e.target.name;

    setTweetOptions({
      ...tweetOptions,
      [e.target.name]: e.target.checked,
    });

    if (name === "liked" && !e.target.checked) {
      setTweetOptions({
        ...tweetOptions,
        [e.target.name]: e.target.checked,
        retweeted: true,
      });
    } else if (name === "retweeted" && !e.target.checked) {
      setTweetOptions({
        ...tweetOptions,
        [e.target.name]: e.target.checked,
        liked: true,
      });
    }
  };

  const handleRunTwitterCampaign = async (url) => {
    setIsLoading(true);
    try {
      const { data } =
        await restService.SocialInteractions.twitter.fetchEntrants(
          campaign.id,
          tweetOptions.retweeted,
          tweetOptions.liked,
          false,
          url,
          user.accessToken
        );
      console.log(data);
      setEntries(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e);
  };

  const handleOpenModal = (entrant) => {
    setSelectedUserObject({
      ...selectedUserObject,
      entrant,
    });
    setShowSendMessageModal(true);
  };

  const handleSendMessage = async (id, message, token) => {
    setIsSendingMessage(true);
    try {
      const data = await restService.SocialInteractions.twitter.sendMessage(
        id,
        message,
        user.accessToken
      );
      console.log(data);
      setSelectedUserObject({
        ...selectedUserObject,
        content: "",
      });
      setSuccess(true);
      // setEntries(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsSendingMessage(false);
    }
  };

  const getListSize = () => {
    const newWidth = Ref?.current?.clientWidth;
    setWidth(newWidth);

    const newHeight = Ref?.current?.clientHeight;
    setHeight(newHeight);
  };

  useEffect(() => {
    getListSize();
  }, [drawWinners]);

  useEffect(() => {
    window.addEventListener("resize", getListSize);
    // console.log("width", width);

    return () => {
      window.removeEventListener("resize", getListSize);
    };
  }, []);

  const handleRunDraw = async () => {
    setOpen(true);
    setIsRewarding(true);
    try {
      const {
        data: { data },
      } = await restService.SocialInteractions.twitter.runDraw(
        campaign.id,
        drawData,
        user.accessToken
      );
      console.log(data);
      setDrawWinners(data);
    } catch (error) {
      console.log(error);
    } finally {
      // setLoading(false);
      setIsRewarding(false);
    }
  };

  const onClose = () => {
    setIsRewarding(false);
    setOpen(false);
  };

  return (
    <div>
      <div>
        <Tabs
          tabs={["Entries", "Draw Winners"]}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
        />
      </div>

      {activeTab === "Entries" ? (
        <>
          <div className="mt-9 flex items-center flex-col relative bg-[#69ACE0] rounded shadow-[0px_0px_4px_rgba(0,_0,_0,_0.1)]">
            <img
              src="https://i.ibb.co/cTxH4MY/channels.png"
              className="md:h-auto h-[130px] object-cover md:object-none"
              alt=""
            />

            <div className="absolute gap-1 md:gap-2 h-full flex flex-col justify-center items-center w-full ">
              <div className="gap-1 md:gap-2 flex justify-center items-center w-full ">
                <input
                  onChange={(e) => setCampaignUrl(e.target.value)}
                  type="text"
                  placeholder="Enter tweet URL"
                  className="md:w-[50%] text-sm rounded border-0"
                />
                <button
                  disabled={!campaignUrl || isLoading}
                  onClick={() => handleRunTwitterCampaign(campaignUrl)}
                  className="rounded bg-[#0079CE] py-2 px-7 text-white text-sm"
                >
                  Run
                </button>
              </div>

              <div className="flex flex-col justify-between">
                <div className="flex gap-4  justify-between items-center">
                  <label htmlFor="retweeted" className="text-sm">
                    Retweeted
                  </label>
                  <input
                    type="checkbox"
                    name="retweeted"
                    // value={tweetOptions.retweeted}
                    checked={tweetOptions.retweeted}
                    onChange={hadleTweetOptionChange}
                  />
                </div>
                <div className="flex  gap-4 justify-between items-center">
                  <label htmlFor="liked" className="text-sm">
                    Liked
                  </label>
                  <input
                    type="checkbox"
                    name="liked"
                    checked={tweetOptions.liked}
                    // value={tweetOptions.liked}
                    onChange={hadleTweetOptionChange}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* date  ::::: search ::::  filter ::::  run draw */}

          <div className="flex gap-2 flex-col md:flex-row justify-between items-start md:items-center w-full mt-11">
            <div className="flex gap-3 w-full justify-start md:items-center flex-col-reverse md:flex-row">
              <div className=" w-auto flex md:justify-start justify-end ">
                <DatePicker
                  state={dateRange}
                  textSize={"text-xs"}
                  setState={setDateRange}
                />
              </div>

              <div className="relative w-auto">
                <label className="relative block">
                  <span className="sr-only">Search</span>
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.21879 9.21873L6.64941 6.64935"
                        stroke="#848484"
                        strokeMiterlimit="10"
                        strokeMiterlimit="square"
                      />
                      <path
                        d="M4.21875 7.65625C6.11723 7.65625 7.65625 6.11723 7.65625 4.21875C7.65625 2.32027 6.11723 0.78125 4.21875 0.78125C2.32027 0.78125 0.78125 2.32027 0.78125 4.21875C0.78125 6.11723 2.32027 7.65625 4.21875 7.65625Z"
                        stroke="#848484"
                        strokeMiterlimit="10"
                        strokeMiterlimit="square"
                      />
                    </svg>
                  </span>
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={(e) => {
                      // setPage(0);
                      handleSearch(e.target.value);
                    }}
                    className="py-1.5 pl-8 border-none focus:border-none focus:pr-10 focus:outline-none rounded-md bg-[#F4F4F4] "
                  />
                </label>
              </div>
            </div>

            {/* filter :::: run a draw */}
            <div className="flex gap-3 w-full justify-end items-center">
              {/* filter */}
              {/* <div className="relative">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.25 1.875H0.625"
                      stroke="#24211D"
                      strokeMiterlimit="10"
                      strokeMiterlimit="square"
                    />
                    <path
                      d="M9.37533 1.875H4.79199"
                      stroke="#24211D"
                      strokeMiterlimit="10"
                      strokeMiterlimit="square"
                    />
                    <path
                      d="M3.54199 3.125C4.23235 3.125 4.79199 2.56536 4.79199 1.875C4.79199 1.18464 4.23235 0.625 3.54199 0.625C2.85164 0.625 2.29199 1.18464 2.29199 1.875C2.29199 2.56536 2.85164 3.125 3.54199 3.125Z"
                      stroke="#24211D"
                      strokeMiterlimit="10"
                      strokeMiterlimit="square"
                    />
                    <path
                      d="M9.375 5H8.75"
                      stroke="#24211D"
                      strokeMiterlimit="10"
                      strokeMiterlimit="square"
                    />
                    <path
                      d="M5.20833 5H0.625"
                      stroke="#24211D"
                      strokeMiterlimit="10"
                      strokeMiterlimit="square"
                    />
                    <path
                      d="M6.45801 6.25C7.14836 6.25 7.70801 5.69036 7.70801 5C7.70801 4.30964 7.14836 3.75 6.45801 3.75C5.76765 3.75 5.20801 4.30964 5.20801 5C5.20801 5.69036 5.76765 6.25 6.45801 6.25Z"
                      stroke="#24211D"
                      strokeMiterlimit="10"
                      strokeMiterlimit="square"
                    />
                    <path
                      d="M1.25 8.125H0.625"
                      stroke="#24211D"
                      strokeMiterlimit="10"
                      strokeMiterlimit="square"
                    />
                    <path
                      d="M9.37533 8.125H4.79199"
                      stroke="#24211D"
                      strokeMiterlimit="10"
                      strokeMiterlimit="square"
                    />
                    <path
                      d="M3.54199 9.375C4.23235 9.375 4.79199 8.81536 4.79199 8.125C4.79199 7.43464 4.23235 6.875 3.54199 6.875C2.85164 6.875 2.29199 7.43464 2.29199 8.125C2.29199 8.81536 2.85164 9.375 3.54199 9.375Z"
                      stroke="#24211D"
                      strokeMiterlimit="10"
                      strokeMiterlimit="square"
                    />
                  </svg>
                </span>
                <select
                  disabled
                  name="filter"
                  id=""
                  className="text-xs hover:bg-[#f4f4f4] pl-8 rounded  "
                >
                  <option value="" selected hidden disabled>
                    filter
                  </option>
                  {/* <option value="hell">yello</option>
              <option value="hell">yello</option>
              <option value="hell">yello</option> */}
              {/* </select> */}
              {/* </div> */}

              {/* run draw */}
              <div className="relative">
                <button
                  onClick={(e) => {
                    openRunADraw("run-a-draw");
                  }}
                  id="run-a-drawbtn"
                  aria-expanded="true"
                  aria-haspopup="true"
                  className="text-sm bg-[#FF6A3A]  hover:bg-[#af4826] transition text-white py-2 px-3 rounded "
                >
                  Run a draw
                </button>

                <div
                  className="border shadow-md w-[280px]  text-sm whitespace-nowrap	rounded py-5 px-4 absolute hidden  origin-top-left bg-white  right-[0px]  mt-2"
                  // className=" ring-1 ring-black ring-opacity-5 focus:outline-none left-0 z-10 shadow-lg w-50 bg-white rounded-lg"
                  aria-orientation="horizontal"
                  aria-labelledby="logout-button"
                  tabIndex="-1"
                  id="run-a-draw"
                >
                  <div className="flex flex-col gap-3">
                    <h4 className="text-base text-[#24211D] font-[500]">
                      Run Draw for:
                    </h4>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex  gap-1 items-center">
                        <input type="radio" name="draw" id="" />
                        <label htmlFor="" className="text-[#848484] text-sm">
                          First Three
                        </label>
                      </div>
                      <div className="flex  gap-1 items-center">
                        <input type="radio" name="draw" id="" />
                        <label htmlFor="" className="text-[#848484] text-sm">
                          First Five
                        </label>
                      </div>
                      <div className="flex  gap-1 items-center">
                        <input type="radio" name="draw" id="" />
                        <label htmlFor="" className="text-[#848484] text-sm">
                          First Twenty
                        </label>
                      </div>
                      <div className="flex  gap-1 items-center">
                        <input type="radio" name="draw" id="" />
                        <label htmlFor="" className="text-[#848484] text-sm">
                          First Ten
                        </label>
                      </div>
                      <div className="flex gap-1 items-center">
                        <input type="radio" name="draw" id="" />
                        <label htmlFor="" className="text-[#848484] text-sm">
                          First Fifty
                        </label>
                      </div>
                      <div className="flex  gap-1 items-center">
                        <input type="radio" name="draw" id="" />
                        <label htmlFor="" className="text-[#848484] text-sm">
                          First Hundred
                        </label>
                      </div>
                    </div>

                    <div className="flex  gap-1 items-center">
                      <input
                        type="checkbox"
                        checked={includeComment}
                        onChange={handleIncludeComment}
                        id=""
                      />
                      <label htmlFor="" className="text-[#848484] ml-2 text-sm">
                        Include Specific Reply
                      </label>
                    </div>

                    {includeComment && (
                      <div>
                        <input
                          type="text"
                          id=""
                          className="rounded text-sm w-full "
                          placeholder="Enter the specific reply here."
                        />
                      </div>
                    )}
                    <div className="mt-5">
                      <button
                        disabled={entries.length < 1}
                        onClick={handleRunDraw}
                        className="text-sm bg-[#FF6A3A] hover:bg-[#af4826] transition text-white py-2 px-3 rounded "
                      >
                        Run a Draw
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* table */}
          <div className="my-4 align-middle bg-white w-full  overflow-auto">
            <Table
              thead={[
                "Name",
                "Twitter Handle",
                "Retweet",
                "Like",
                // "Follower",
                // "Action",
              ]}
              dataRow={
                <>
                  {isLoading ? (
                    <tr className="w-full">
                      <td className="text-center" colSpan="5">
                        <div className="my-8 mx-auto">
                          <PulseLoader color="#FF6A3A" />
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {entries < 1 ? (
                        <tr className="w-full">
                          <td className="text-center" colSpan="5">
                            <div className="my-8 mx-auto">
                              <img
                                src={require("../../../../../assets/images/noData.svg")}
                                alt=""
                                className="mx-auto"
                              />
                            </div>
                          </td>
                        </tr>
                      ) : (
                        <>
                          {entries
                            .filter((item) => {
                              if (searchTerm) {
                                return (
                                  item.name
                                    .toLowerCase()
                                    .includes(searchTerm.toLocaleLowerCase()) ||
                                  item.handle
                                    .toLowerCase()
                                    .includes(searchTerm.toLocaleLowerCase())
                                );
                              } else {
                                return item;
                              }
                            })
                            .map((item, index) => (
                              <tr
                                key={index}
                                className="hover:bg-[#F4F4F4]  focus:bg-[#F4F4F4] "
                              >
                                <td className="text-[#848484]  whitespace-nowrap text-center text-xs md:text-sm py-6 pl-6 capitalize">
                                  {item.name}
                                </td>
                                <td className="text-[#848484]  whitespace-nowrap text-center text-xs md:text-sm py-6 pl-6 capitalize">
                                  @{item?.handle}
                                </td>
                                <td className="text-[#848484]  whitespace-nowrap text-center text-xs md:text-sm py-6 pl-6 capitalize">
                                  {item?.retweeted ? 1 : 0}
                                </td>
                                <td className="text-[#848484]  whitespace-nowrap text-center text-xs md:text-sm py-6 pl-6 capitalize">
                                  {item?.liked ? 1 : 0}
                                </td>
                                {/* <td className="text-[#848484]  whitespace-nowrap text-center text-xs md:text-sm py-6 pl-6 capitalize">
                                  {item?.follower ? "Yes" : "No"}
                                </td> */}
                                {/* <td className=" text-[#848484] whitespace-nowrap text-center text-xs md:text-sm py-6 pl-6 capitalize">
                                  <button
                                    onClick={() => handleOpenModal(item)}
                                    className="border-[#848484] hover:bg-[#f4f4f4] border text-sm rounded-[45px] py-1 px-3"
                                  >
                                    Send Message
                                  </button>
                                </td> */}
                              </tr>
                            ))}
                        </>
                      )}
                    </>
                  )}
                </>
              }
            />
          </div>

          {/* send message */}
          <ModalComponent
            showModal={showSendMessageModal}
            width={"max-w-xl"}
            setShowModal={setShowSendMessageModal}
            handleClose={handleClose}
          >
            <div className="flex items-center flex-col w-full justify-center gap-9 py-[37px]">
              <h1 className="font-[600] text-2xl">Send Message</h1>

              <div className="flex flex-col gap-4">
                <p>
                  To:{" "}
                  <span className="text-[500]">
                    @
                    {Object.keys(selectedUserObject).length > 1 &&
                      selectedUserObject.entrant.handle}
                  </span>{" "}
                </p>

                <div className="flex flex-col gap-1">
                  <label htmlFor="message" className="text-sm">
                    Message
                  </label>
                  <textarea
                    className=" border-gray-400"
                    name="message"
                    id=""
                    cols="30"
                    rows="5"
                    placeholder="Enter message here"
                    onChange={(e) => {
                      setSuccess(false);
                      setSelectedUserObject({
                        ...selectedUserObject,
                        content: e.target.value,
                      });
                    }}
                  />
                </div>

                <div className="flex justify-end">
                  {!isSendingMessage && !success ? (
                    <button
                      disabled={!selectedUserObject.content}
                      onClick={() =>
                        handleSendMessage(
                          selectedUserObject.entrant.id,
                          selectedUserObject.content
                        )
                      }
                      className="rounded bg-[#0079CE] py-2 px-7 text-white text-base"
                    >
                      Send
                    </button>
                  ) : isSendingMessage && !success ? (
                    <p className="rounded bg-[#0079CE] py-2 px-7 text-white text-base">
                      Sending message...
                    </p>
                  ) : (
                    <p>Message sent successfully</p>
                  )}
                </div>
              </div>
            </div>
          </ModalComponent>

          <Modal show={open} size="3xl" placement="center" onClose={onClose}>
            <div ref={Ref} className="h-[70vh]">
              {/* Invite member */}
              {isRewarding ? (
                <div className="md:p-12 p-5 flex justify-center flex-col items-center">
                  <h4 className=" text-[24px] font-[700] text-[#24211D]">
                    Please wait...
                  </h4>
                  <p className=" text-[14px] text-[#b4b4b4]">
                    Selecting winner(s)
                  </p>

                  <div className=" flex md:flex-row  items-center gap-1 md:gap-3 mt-1">
                    <PulseLoader color="#FF6A3A" />
                  </div>
                </div>
              ) : (
                // success

                <>
                  <div className="md:py-10 h-[57vh]  md:px-10 p-5 mx-auto flex  flex-col items-center">
                    {drawWinners.length < 1 ? (
                      <h4 className=" text-[24px] font-[700] text-[#24211D] uppercase">
                        Winners
                      </h4>
                    ) : (
                      <h4 className=" text-[24px] font-[700] text-[#24211D] uppercase">
                        Winner(s)
                        {drawData.length > 0 &&
                          drawData?.drawType.toLowerCase()}
                      </h4>
                    )}

                    {drawWinners && drawWinners.length > 0 ? (
                      <div className="w-full">
                        <div className=" flex md:flex-row  items-center gap-1 md:gap-3 mt-1">
                          <Confetti width={width} height={height} />
                        </div>
                        <div
                          // ref={ref}

                          className="flex flex-wrap gap-4 justify-center align-center w-full mt-3 overflow-y-scroll"
                        >
                          {drawWinners.map((winner, index) => (
                            <div key={index}>
                              <p className="text-base bg-[#e7e7e7] px-3 py-2 rounded">
                                @{winner.twitterHandle}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="flex h-[37vh]  mt-3 text-[#b4b4b4] items-center justify-center">
                          <p>No Winner Found.</p>
                        </div>
                      </>
                    )}
                  </div>

                  <div className=" flex md:flex-row gap-4 justify-center  items-center md:gap-3 mb-3">
                    <button
                      className=" border rounded py-2 mb-10 md:text-base text-xs px-7 hover:bg-[#00C74C] transition hover:text-white bg-[#00C74C1a] text-[#00C74C]"
                      onClick={() => {
                        // setIsRunDraw(false);
                        onClose();
                      }}
                    >
                      Try Again
                    </button>
                    <button
                      className=" border rounded py-2 mb-10 md:text-base text-xs px-7 hover:bg-[#ff0000] transition hover:text-white bg-[#c700001a] text-red-600"
                      onClick={() => {
                        // setIsRunDraw(false);
                        setActiveTab("Draw Winners");
                        onClose();
                      }}
                    >
                      Close
                    </button>
                  </div>
                </>
              )}
            </div>
          </Modal>
        </>
      ) : (
        <DrawWinners drawWinners={drawWinners} />
      )}
    </div>
  );
};

export default TwitterCampaigns;
